import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import fetch from '../../core/fetch';
import MessageModal from './MessageModal';

class MessageDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.userData,
      login: this.props.login,
      topic: null,
      receiver: null,
      messages: [],
      topic_id: this.props.id,
      content: '',
      file: null,
      showMessage: false,
      contentMessage: null,
      fileUploaded: true,
    };
  }

  componentDidMount() {
    // Pobiera wszystkie wiadomosci z tematu
    const url_msg = `${process.env.API_URL}/invest/message/${this.state.topic_id}`;
    // let url_msg = `http://localhost:8000/api/v1.0/invest/message/${this.state.topic_id}`;
    fetch(url_msg)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          messages: resp.messages,
        });
      });

    // let url_check = `${process.env.API_URL}/invest/checkUpload/${this.state.topic_id}`;
    const url_check = `http://localhost:8000/api/v1.0/invest/checkUpload/${this.state.topic_id}`;
    fetch(url_check)
      .then(r => r.json())
      .then(resp => {
        if (resp.exists) {
          this.setState({
            fileUploaded: true,
          });
        } else {
          this.setState({
            fileUploaded: false,
          });
        }
      });
  }

  // Generuje i przekierowuje do dokumentu pdf
  generatePDF = () => {
    const url = `${process.env.API_URL}/invest/create_pdf/${this.state.topic_id}`;
    // let url = `http://localhost:8000/api/v1.0/invest/create_pdf/${this.state.topic_id}`;

    window.location.href = url;
  };

  getUploaded = () => {
    // let url = `${process.env.API_URL}/invest/create_pdf/${this.state.topic_id}`;
    const url = `http://localhost:8000/api/v1.0/invest/getUploaded/${this.state.topic_id}`;

    window.location.href = url;
  };

  onFormSubmit(e) {
    e.preventDefault(); // Stop form submit

    const url_msg = `http://localhost:8000/api/v1.0/invest/upload/${this.state.topic_id}`;
    const formData = new FormData();
    formData.append('file', this.state.file);

    fetch(url_msg, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
    })
      .then(r => r.json())
      .then(resp => {
        this.setState({
          showMessage: true,
          contentMessage: resp.msg,
        });

        if (resp.uploaded) {
          this.setState({
            fileUploaded: true,
          });
        }
      });
  }

  fileChange(e) {
    const file_form = e.target.files[0];
    this.setState({ file: file_form });
  }

  // Podmienia state
  handleChange = e => {
    this.setState({
      content: e.target.value,
    });
  };

  // Wysylamy wiadomosc do konkretnego tematu
  sendMessage = () => {
    const data = {
      content: this.state.content,
      fk_topic: this.state.topic_id,
      fk_userid: this.state.user.ID,
    };

    const url = `${process.env.API_URL}/invest/message/${this.state.topic_id}`;
    // let url = `http://localhost:8000/api/v1.0/invest/message/${this.state.topic_id}`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, */*',
      },
      body: JSON.stringify(data),
    })
      .then(r => r.json())
      .then(resp => {
        // Odświeżamy listę wiadomości żeby od razu widzieli zmiany, a nie po odswiezeniu strony
        const url_msg = `${process.env.API_URL}/invest/message/${this.state.topic_id}`;
        // let url_msg = `http://localhost:8000/api/v1.0/invest/message/${this.state.topic_id}`;
        fetch(url_msg)
          .then(r => r.json())
          .then(resp => {
            this.setState({
              messages: resp.messages,
              content: '',
            });
          });
      });
  };

  render() {
    return (
      <div>
        {this.state.showMessage ? (
          <MessageModal
            openModal={this.state.showMessage}
            content={this.state.contentMessage}
            closeModal={() => this.setState({ showMessage: false })}
          />
        ) : null}
        <div className={s.delContainer} style={{ display: 'block' }}>
          <div className={s.delTitle}>List intencyjny</div>
          <GrayPanel title="List intencyjny">
            <div className="col-md-4">
              <button className="btn btn-primary" onClick={() => this.generatePDF()}>
                Wygeneruj list intencyjny
              </button>
            </div>
          </GrayPanel>
        </div>

        <div className={s.delContainer} style={{ display: 'block' }}>
          <GrayPanel title="Konwersacja">
            {this.state.messages.map((v, i) => {
              if (this.state.receiver == null && this.state.user.ID != v.fk_userid) {
                const url = `${process.env.API_URL}/users/get/${v.fk_userid}`;
                // let url = `http://localhost:8000/api/v1.0/users/get/${v.fk_userid}`;

                fetch(url)
                  .then(r => r.json())
                  .then(resp => {
                    this.setState({
                      receiver: resp.receiver,
                    });
                  });
              }
              return (
                <div>
                  {this.state.user.ID == v.fk_userid ? (
                    <div key={i}>
                      <div className={s.my}>
                        <div className={s.messagemy}>{v.content}</div>
                        <div className={s.messageinfomy}>
                          <b>
                            {this.state.user.FirstName} {this.state.user.LastName}
                          </b>, {v.created}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div key={i}>
                      <div className={s.notmy}>
                        <div className={s.messagenotmy}>{v.content}</div>
                        <div className={s.messageinfo}>
                          <b>
                            {this.state.receiver.FirstName} {this.state.receiver.LastName}
                          </b>, {v.created}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            <div className="form-group">
              <label>Wiadomość</label>
              <textarea
                className="form-control"
                onChange={e => this.handleChange(e)}
                value={this.state.content}
                placeholder="Wpisz wiadomość..."
              />
            </div>
            <div className="form-group pull-right">
              <button className="btn btn-primary" onClick={() => this.sendMessage()}>
                Wyślij wiadomość
              </button>
            </div>
          </GrayPanel>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(MessageDetail);



// WEBPACK FOOTER //
// src/routes/MessageDetail/index.js